module.exports = __webpack_public_path__ + "static/media/add.18338170.svg";